import { Button, Flex, Text, TextField } from "@radix-ui/themes";

import type { TitleSymbolFieldControllerValue } from "./TitleSymbolField.controller";

export type TitleSymbolFieldPresentationProps = TitleSymbolFieldControllerValue;

export const TitleSymbolFieldPresentation = ({
  value,
  error,
  editing,
  draft,
  inputRef,
  onStartEditing,
  onDraftChange,
  onBlur,
  onKeyDown,
}: TitleSymbolFieldPresentationProps) => (
  <Flex align="center" gap="1" minWidth="0">
    {editing ? (
      <TextField.Root
        ref={inputRef}
        size="1"
        aria-label="Symbol"
        value={draft}
        onChange={(event) => onDraftChange(event.target.value)}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        className="workspace-widget__title-symbol-input"
      />
    ) : (
      <Button
        type="button"
        variant="ghost"
        color="gray"
        size="1"
        onClick={onStartEditing}
        className="workspace-widget__title-symbol-trigger"
      >
        <Text size="1" color="gray" highContrast={Boolean(value)}>
          {value ?? "Symbol"}
        </Text>
      </Button>
    )}
    {error ? (
      <Text role="alert" size="1" color="red">
        {error}
      </Text>
    ) : null}
  </Flex>
);
